// extracted by mini-css-extract-plugin
export var blockwidth = "70px";
export var bordercolor = "#aaa";
export var header = "ComicHeader-module--header--9e1e4";
export var image = "ComicHeader-module--image--be567";
export var imageContainer = "ComicHeader-module--imageContainer--80eef";
export var name = "ComicHeader-module--name--80885";
export var pixelart = "ComicHeader-module--pixelart--2c979";
export var price = "ComicHeader-module--price--db936";
export var textcolor = "white";